var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconComment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5C3 4.44772 3.44772 4 4 4H20C20.5523 4 21 4.44772 21 5V16C21 16.5523 20.5523 17 20 17H12.4142L8.70711 20.7071C8.42111 20.9931 7.99099 21.0787 7.61732 20.9239C7.24364 20.7691 7 20.4045 7 20V17H4C3.44772 17 3 16.5523 3 16V5ZM5 6V15H8C8.55228 15 9 15.4477 9 16V17.5858L11.2929 15.2929C11.4804 15.1054 11.7348 15 12 15H19V6H5Z",
    fill: "#040405"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComment);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zIDVDMyA0LjQ0NzcyIDMuNDQ3NzIgNCA0IDRIMjBDMjAuNTUyMyA0IDIxIDQuNDQ3NzIgMjEgNVYxNkMyMSAxNi41NTIzIDIwLjU1MjMgMTcgMjAgMTdIMTIuNDE0Mkw4LjcwNzExIDIwLjcwNzFDOC40MjExMSAyMC45OTMxIDcuOTkwOTkgMjEuMDc4NyA3LjYxNzMyIDIwLjkyMzlDNy4yNDM2NCAyMC43NjkxIDcgMjAuNDA0NSA3IDIwVjE3SDRDMy40NDc3MiAxNyAzIDE2LjU1MjMgMyAxNlY1Wk01IDZWMTVIOEM4LjU1MjI4IDE1IDkgMTUuNDQ3NyA5IDE2VjE3LjU4NThMMTEuMjkyOSAxNS4yOTI5QzExLjQ4MDQgMTUuMTA1NCAxMS43MzQ4IDE1IDEyIDE1SDE5VjZINVoiIGZpbGw9IiMwNDA0MDUiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };